export default "__VITE_ASSET__RdUSG$wG__"